import { render, staticRenderFns } from "./groupRelationDevice.vue?vue&type=template&id=147f0afe&scoped=true&"
import script from "./groupRelationDevice.vue?vue&type=script&lang=ts&"
export * from "./groupRelationDevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f0afe",
  null
  
)

export default component.exports